import { styled } from '@mui/system';

export const CardsAlignment = styled('section')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(1, 1, 0, 1),
  margin: theme.spacing(3, 3, 3, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 0, 0)
  }
}));
